module.exports = __webpack_public_path__ + "img/eg.99dfda5e.svg";